/**
 * Check Product Inventory JS
 */
jQuery(document).ready(function ($) {
  const primary = document.getElementById('primary');
  const targetElement = primary.querySelector('ul.products');
  let quickView = $('a.quick-view');

  const popQuickView = function () {
    $.magnificPopup.open({
      items: {
        src: '#quick-view-popup',
        closeBtnInside: true,
        autoFocusLast: true,
        focus: '#quick-view-title',
      },
    });
  };

  const initQuickView = function (product, content) {
    let src = product.find('img').attr('src');
    let title = product.find('.woocommerce-loop-product_title a').html();
    let link = product.find('.woocommerce-loop-product_title a').attr('href');

    $('#quick-view-image img').attr('src', src);
    $('#quick-view-title').html(title);
    $('#quick-view-content').html(content);
    $('#quick-view-link').attr('href', link);

    popQuickView();
  };

  if (targetElement) {
    const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          $('a.quick-view').on('click', function () {
            initQuickView($(this).closest('.product'), $(this).data('content'));
          });
        }
      });
    });
    observer.observe(targetElement, { childList: true });
  }

  quickView.on('click', function () {
    initQuickView($(this).closest('.product'), $(this).data('content'));
  });
});
